import { useRoute } from "vue-router";
export default {
    setup: function () {
        var route = useRoute();
        return { route: route };
    }
};
